var _g, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCiscoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 96,
    viewBox: "0 0 220 96",
    role: "img",
    "aria-label": "Cisco",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00BCEB"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 20,
    width: 3.4,
    height: 14,
    rx: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 12,
    width: 3.4,
    height: 22,
    rx: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 24,
    width: 3.4,
    height: 10,
    rx: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 24,
    width: 3.4,
    height: 10,
    rx: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 6,
    width: 3.4,
    height: 28,
    rx: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 24,
    width: 3.4,
    height: 10,
    rx: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 24,
    width: 3.4,
    height: 10,
    rx: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 12,
    width: 3.4,
    height: 22,
    rx: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 20,
    width: 3.4,
    height: 14,
    rx: 1.7
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 80,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 44,
    fontWeight: 400,
    letterSpacing: 1,
    fill: "#0D274D"
  }, "cisco")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiscoLogo);
export default __webpack_public_path__ + "static/media/cisco-logo.61063f92553c4e62ece1c3ee919670a1.svg";
export { ForwardRef as ReactComponent };